import Footer from '@components/shared/Footer/Footer';
import VerifyMobileNumberForm from '@components/VerifyMobileNumberForm/VerifyMobileNumberForm';
import { useTexts } from 'utils/useTexts';

const VerifyMobileNumber = () => {
  const { t } = useTexts();
  return (
    <>
      <VerifyMobileNumberForm />

      <Footer text={t('verifyMobileNumber.footer')} />
    </>
  );
};

export default VerifyMobileNumber;
